import React from "react";
import { Link } from "react-router-dom";

const PageTitle = ({
  pageHeading,
  motherMenu,
  activeMenu,
  previousPath,
  stateData,
  stateDataPage,
  search,
  data,
}) => {
  return (
    <div className="page-titles mc-page-title">
      <div className="mc-page-title__heading">
        <h4 className="mc-page-title__title">{activeMenu || pageHeading}</h4>
      </div>
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
          {previousPath ? (
            <Link
              to={previousPath}
              state={{
                selectedTab: stateData,
                page: stateDataPage,
                search: search,
                data: data,
                from: motherMenu == "User Details" ? "userList" : "",
              }}
            >
              {motherMenu}
            </Link>
          ) : (
            <span>{motherMenu}</span>
          )}
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          <span>{activeMenu}</span>
        </li>
      </ol>
    </div>
  );
};

export default PageTitle;
